import { useLocalStorage } from '@vueuse/core'
import { useGetJwt } from '~/composables/api/supabase/get-jwt'

type DashboardPreferences = Record<string, unknown>

export const useDashboardPreference = <T>(
   name: MaybeRefOrGetter<string>,
   defaultValue: MaybeRefOrGetter<T>,
   isValid: (value: unknown) => value is T
) => {
   const organizationId = useOrganizationId()
   const jwt = useGetJwt()

   const storageKey = computed(
      () => `dashboard-preferences-${jwt.value?.user_details?.id ?? ''}-${organizationId.value}`
   )
   const preferences = useLocalStorage<DashboardPreferences>(
      storageKey,
      {},
      { initOnMounted: true }
   )

   return computed<T>({
      get: () => {
         const value = preferences.value?.[toValue(name)]
         return isValid(value) ? value : toValue(defaultValue)
      },
      set: (value) => {
         preferences.value = { ...preferences.value, [toValue(name)]: value }
      },
   })
}

export const isStringArray = (value: unknown): value is string[] =>
   Array.isArray(value) && value.every((item) => typeof item === 'string')

export const gridColumnSortPreferenceName = (gridId: string | undefined) =>
   `grid-column-sort-${gridId}`
